import { createContext } from 'ui/lib/react-utils'
import { type UseSearchReturnType } from '../../../../search/hooks/useSearch'

export interface MobileMenuContextState {
  search?: Pick<
    UseSearchReturnType,
    'data' | 'onKeyDown' | 'inputRef' | 'searchQuery' | 'isLoading'
  >
}

export const [MobileMenuContextProvider, useMobileMenuContext] =
  createContext<MobileMenuContextState>({
    name: 'MobileMenuContext'
  })
